import { render } from "./achievement_list.vue?vue&type=template&id=0fde9f88&scoped=true"
import script from "./achievement_list.vue?vue&type=script&lang=js"
export * from "./achievement_list.vue?vue&type=script&lang=js"

import "./achievement_list.vue?vue&type=style&index=0&id=0fde9f88&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-szty\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fde9f88"]])

export default __exports__